/**
 * Per-component prop defaults for the app's Vuetify instance.
 *
 * Kept out of `vuetify.ts` so the unit-test setup can install the same defaults
 * without importing that module's icon set — `tests/unit/setup.ts` runs once per
 * test file, and pulling `@mdi/js` into all of them is not free.
 *
 * A component test that builds its own `createVuetify` must pass these, or it
 * exercises a Vuetify configured differently from production and can neither
 * catch a regression here nor be trusted about behaviour that depends on it.
 */
export const vuetifyDefaults = {
  // Vuetify tooltips default to eager mounting. A repeated tooltip then adds a
  // document-level click listener for every row, so keep the default lazy.
  // Focusing the activator still mounts it and resolves `aria-describedby`.
  // `vuetify.spec.ts` covers both properties of this default.
  VTooltip: { eager: false },
};
